import baseUrl from '../baseUrl';

const URL_CRIAR_CATEGORIA = `${baseUrl}/doc/categoria`;

const criarCategoria = async (diretoria, categoria) => {
  try {
    const response = await fetch(`${URL_CRIAR_CATEGORIA}`, {
      method: 'PATCH',
      headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        diretoria,
        categoria
      })
    });

    if (!response.ok) {
      throw new Error('Ocorreu um erro inesperado');
    }

    return response.json();
  } catch (error) {
    console.log(error);
  }
};

export default criarCategoria;
